import { CustomerAppAppearanceOptionsVoData } from "../..";
var OrganizationDetailsVoData = /** @class */ (function () {
    function OrganizationDetailsVoData(id) {
        this.fileUrl = "";
        this.id = id;
    }
    Object.defineProperty(OrganizationDetailsVoData.prototype, "uid", {
        get: function () {
            return this.id;
        },
        enumerable: true,
        configurable: true
    });
    OrganizationDetailsVoData.prototype.getAppearanceOptionsClone = function () {
        var appearanceOptionsClone = new CustomerAppAppearanceOptionsVoData(this.appearanceOptions.id);
        appearanceOptionsClone.id = this.appearanceOptions.id;
        appearanceOptionsClone.mainColor = this.appearanceOptions.mainColor;
        appearanceOptionsClone.bodyColor = this.appearanceOptions.bodyColor;
        appearanceOptionsClone.mainBGColor = this.appearanceOptions.mainBGColor;
        appearanceOptionsClone.menuBGColor = this.appearanceOptions.menuBGColor;
        appearanceOptionsClone.mainTextColor = this.appearanceOptions.mainTextColor;
        appearanceOptionsClone.secondaryButtonTextColor = this.appearanceOptions.secondaryButtonTextColor;
        appearanceOptionsClone.secondaryButtonColor = this.appearanceOptions.secondaryButtonColor;
        appearanceOptionsClone.langKey = this.appearanceOptions.langKey;
        appearanceOptionsClone.customLangFileId = this.appearanceOptions.customLangFileId;
        appearanceOptionsClone.showBranding = this.appearanceOptions.showBranding;
        appearanceOptionsClone.showCustomerApp = this.appearanceOptions.showCustomerApp;
        appearanceOptionsClone.useLogo = this.appearanceOptions.useLogo;
        appearanceOptionsClone.useFrom = this.appearanceOptions.useFrom;
        appearanceOptionsClone.logoFileKey = this.appearanceOptions.logoFileKey;
        appearanceOptionsClone.smallBubbleMessage = this.appearanceOptions.smallBubbleMessage;
        appearanceOptionsClone.botImageUrl = this.appearanceOptions.botImageUrl;
        appearanceOptionsClone.botName = this.appearanceOptions.botName;
        return appearanceOptionsClone;
    };
    return OrganizationDetailsVoData;
}());
export { OrganizationDetailsVoData };
//# sourceMappingURL=organization-details-vo-data.js.map


//////////////////
// WEBPACK FOOTER
// ../od-ts/dist/vo/organization/organization-details-vo-data.js
// module id = 947
// module chunks = 14